
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "1af50046-f791-40b0-b460-061b02d0f50e"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/src/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
